import type { ITimelinePeriod } from '@features/timeline/types';

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { TIMELINE_MODE } from '@features/timeline/constants';
import { getPeriodByTimelineMode } from '@features/timeline/utils/getPeriodByTimelineMode';

interface IInitialState {
  mode: TIMELINE_MODE;
  period: ITimelinePeriod;
}

const initialState: IInitialState = {
  mode: TIMELINE_MODE.WEEK,
  period: getPeriodByTimelineMode(TIMELINE_MODE.WEEK, 'UTC'),
};

const timelineSlice = createSlice({
  initialState,
  name: 'timelineSlice',
  reducers: {
    setTimelinePeriod(state, action: PayloadAction<ITimelinePeriod>) {
      state.period = action.payload;
    },
    setInitialTimelinePeriod(
      state,
      action: PayloadAction<{ timezone: string }>
    ) {
      state.period = getPeriodByTimelineMode(
        state.mode,
        action.payload.timezone
      );
    },
    setTimelineMode(
      state,
      action: PayloadAction<{ timezone: string; mode: TIMELINE_MODE }>
    ) {
      state.mode = action.payload.mode;
      state.period = getPeriodByTimelineMode(
        action.payload.mode,
        action.payload.timezone
      );
    },
  },
});

export default timelineSlice.reducer;
export const { setTimelineMode, setTimelinePeriod, setInitialTimelinePeriod } =
  timelineSlice.actions;
